import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_ADDNOTE_FULFILLED = "FETCH_ADDNOTE_FULFILLED";
export const FETCH_ADDNOTE_REJECTED = "FETCH_ADDNOTE_REJECTED";
export const FETCH_ADDNOTE_PENDING = "FETCH_ADDNOTE_PENDING";
export const RESET_ADDNOTE = "RESET_ADDNOTE"

export function addNote(careProviderData, surveyData) {
    const token = localStorage.getItem("accessToken")

    return (dispatch) => {
        dispatch({
            type: "FETCH_ADDNOTE",
            payload: axios({
                method: "post",
                url: `${API_BASE}/api/v3/second-opinion/add-note-to-application`,
                data: { careProviderData, surveyData },
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetAddNote() {
    return (dispatch) => {
        dispatch({
            type: "RESET_ADDNOTE",
        });
    };
}




